module.exports = __webpack_public_path__ + "static/media/9_r_blok_69.32_87.31.727e3cf5.png";